import { render } from "./ClaimExpenses.vue?vue&type=template&id=15007d2c&scoped=true"
import script from "./ClaimExpenses.vue?vue&type=script&lang=js"
export * from "./ClaimExpenses.vue?vue&type=script&lang=js"

import "./ClaimExpenses.vue?vue&type=style&index=0&id=15007d2c&scoped=true&lang=scss"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15007d2c"]])

export default __exports__